import { clsx } from 'clsx';
import { type FC } from 'react';

import styles from './SkeletonRect.css';

type TSkeletonRectProps = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'children'
> & {
  height?: number | string;
  width?: number | string;
  borderRadius?: number | string;
};

export const SkeletonRect: FC<TSkeletonRectProps> = ({ height, width, borderRadius, ...passedProps }) => {
  return (
    <div
      {...passedProps}
      className={clsx(passedProps.className, styles['root'])}
      style={{
        height,
        width,
      }}
    >
      <div
        className={styles['fill']}
        style={{
          borderRadius,
        }}
      />
    </div>
  );
};
